import React, { useState } from "react";
import { Spinner } from "../../../assets/icon/svg";
import { MingcuteMailSendFill } from "../../../assets/icon/iconify";
import CloseButtonModal from "../../ui/close-button-modal";
import { useAuthActions } from "../../../hooks/actions/use-auth-actions";
import { useAuthDataState } from "../../../hooks/data-state/use-auth-data-state";
import OtpInput from "./otp-input";

export default function VerifyOtp() {
    const {
        handleVerifyOTP,
        handleResendOTP,
        isLoadingVerifyResend,
        handleCloseVerifyOTPModal,
    } = useAuthActions();

    const { pendingEmail } = useAuthDataState();

    const [otp, setOtp] = useState("");

    const isHasEmail = !pendingEmail || pendingEmail.length === 0;
    const isCodeComplete = otp.length === 6;

    const handleVerify = () => {
        if (!isCodeComplete) return;
        handleVerifyOTP(otp);
    };

    return (
        <div className="fixed inset-0 z-[101] flex items-center justify-center bg-black/30 p-4 backdrop-blur-sm">
            <div className="relative w-full max-w-md overflow-hidden rounded-2xl border border-white/70 bg-white shadow-[0_25px_70px_-20px_rgba(24,108,178,0.25)]">
                <div className="absolute left-0 top-0 h-1 w-full bg-[#186cb2]" />

                <div className="relative px-5 py-4 sm:px-6 sm:py-5">
                    <div className="flex items-start justify-between gap-4">
                        <div>
                            <p className="text-lg font-bold tracking-tight text-gray-900 sm:text-xl">
                                Verify your account
                            </p>

                            <p className="mt-0.5 text-xs text-gray-500 sm:text-sm">
                                Enter the verification code we sent to you.
                            </p>
                        </div>

                        <CloseButtonModal handleClose={handleCloseVerifyOTPModal} />
                    </div>

                    <div className="mt-4 flex justify-center">
                        <div className="flex h-16 w-16 items-center justify-center rounded-2xl border border-[#186cb2]/10 bg-[#186cb2]/5">
                            <MingcuteMailSendFill
                                color="#186cb2"
                                height={34}
                                width={34}
                            />
                        </div>
                    </div>

                    <div className="mt-4 text-center">
                        <p className="text-sm leading-5 text-gray-600">
                            Please check your inbox or spam folder for the One Time Passcode.
                        </p>

                        {pendingEmail && (
                            <div className="mt-2 inline-flex max-w-full items-center rounded-lg border border-[#186cb2]/10 bg-[#186cb2]/5 px-3 py-1.5">
                                <span className="truncate text-xs font-semibold text-[#186cb2]">
                                    {pendingEmail}
                                </span>
                            </div>
                        )}
                    </div>

                    <div className="mt-5">
                        <OtpInput
                            disabled={isLoadingVerifyResend}
                            onComplete={setOtp}
                        />
                    </div>

                    <button
                        type="button"
                        onClick={handleVerify}
                        disabled={isHasEmail || !isCodeComplete || isLoadingVerifyResend}
                        className={`mt-5 flex w-full items-center justify-center rounded-xl py-2.5 text-sm font-semibold shadow-sm transition-all ${
                            isHasEmail || !isCodeComplete || isLoadingVerifyResend
                                ? "cursor-not-allowed bg-gray-300 text-gray-500"
                                : "bg-[#186cb2] text-white hover:bg-[#155f9d] hover:shadow-lg hover:shadow-[#186cb2]/20 active:scale-[0.99]"
                        }`}
                    >
                        {isLoadingVerifyResend ? (
                            <div className="flex items-center justify-center gap-2">
                                <Spinner size={17} />
                                <span>Verifying...</span>
                            </div>
                        ) : (
                            <span>Verify OTP</span>
                        )}
                    </button>

                    <div className="mt-3 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-center">
                        <span className="text-xs text-gray-500 sm:text-sm">
                            Didn't receive the OTP?
                        </span>

                        <button
                            type="button"
                            onClick={handleResendOTP}
                            disabled={isLoadingVerifyResend}
                            className="font-semibold text-[#186cb2] transition hover:text-[#155f9d] hover:underline disabled:cursor-not-allowed disabled:opacity-50"
                        >
                            {isLoadingVerifyResend ? (
                                <div className="flex items-center gap-1.5">
                                    <Spinner color="#186cb2" size={15} />
                                    <span className="text-xs sm:text-sm">
                                        Sending...
                                    </span>
                                </div>
                            ) : (
                                <span className="text-xs sm:text-sm">
                                    Resend OTP
                                </span>
                            )}
                        </button>
                    </div>

                    <div className="mt-4 flex items-center justify-center gap-2 text-[10px] text-gray-400">
                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                            <rect width="18" height="11" x="3" y="11" rx="2" />
                            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                        </svg>

                        <span>Your verification is secure</span>
                    </div>
                </div>
            </div>
        </div>
    );
}